// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"DM-z","carouselContainer":"EM-z"};